export default {
  actualValue: 'Actual value',
};
